import { BasePageQuotation, Footer } from 'design-system';
import {
  makeStyles,
  createStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useFeatureValue } from '@growthbook/growthbook-react';
import DesktopMaintenanceLayout from './DesktopMaintenanceLayout';
import MobileMaintenanceLayout from './MobileMaintenanceLayout';

const urlBackgroundMaintenence = 'svg/maintenance-background.svg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    container: {
      flexGrow: 1,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      background: `linear-gradient(359.66deg, rgba(242, 244, 243,0.4) 13.26%, rgba(255, 255, 255,0.4) 88.97%),url("${urlBackgroundMaintenence}")`,
      [theme.breakpoints.up('md')]: {
        backgroundSize: '100%',
      },
    },
    footer: {
      marginTop: 'auto',
    },
    innerContainer: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: 'calc(100vh - 220px)',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

const MaintenanceScreen = (): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleReload = (): void => {
    window.location.reload();
  };
  const maintenanceFinishTime = useFeatureValue(
    'fwm-time-finish-maintenance',
    '11:30 pm',
  );
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <BasePageQuotation
          data-testid="maintenance-content"
          rightActions={null}
          leftActions={null}
          backgroundColor="white"
        >
          <div className={classes.innerContainer}>
            {isMobile ? (
              <MobileMaintenanceLayout
                onReload={handleReload}
                finishTime={maintenanceFinishTime}
                data-testid="mobile-maintenance"
              />
            ) : (
              <DesktopMaintenanceLayout
                onReload={handleReload}
                finishTime={maintenanceFinishTime}
                data-testid="desktop-maintenance"
              />
            )}
          </div>
        </BasePageQuotation>
      </div>
      <footer data-testid="footer" className={classes.footer}>
        <Footer
          IsMobile={isMobile}
          country="Costa Rica"
          linkText="Consulte nuestros términos y condiciones"
          linkHref="https://www.assanet.cr/condiciones-generales/#seguros-generales"
        />
      </footer>
    </div>
  );
};

export default MaintenanceScreen;
